import { stickyBannerHeightDesktop } from '@/vdp/StickyBanner/BannerStyles';
import { desktopNavHeight } from './constants';

const getElementOffsetTop = (elem: HTMLElement) =>
  elem.getBoundingClientRect().top +
  window.scrollY -
  desktopNavHeight -
  stickyBannerHeightDesktop;

export default getElementOffsetTop;
